/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";

import Header from "../component/Header";
import Mint from "../component/Mint";
import About from "../component/About";
import Traits from "../component/Traits";
import Collection from "../component/Collection";
import Roadmap from "../component/Roadmap";
import FAQ from "../component/FAQ";
import Footer from "../component/Footer";

import {
  checkConnection,
  getCurrentWalletConnected,
  mintNFT,
  totalSupply,
  Cost,
  checkNetwork,
} from "../utils/interact";

function App() {
  const [walletAddress, setWallet] = useState("");
  const [status, setStatus] = useState("");
  const [price, setPrice] = useState(0.02);
  const [amount, setAmount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [supply, setSupply] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    const { address, status } = await getCurrentWalletConnected();
    setWallet(address);
    setStatus(status);
    addWalletListener();
  }, []);

  // function inArray(needle, haystack) {
  //   var length = haystack.length;
  //   for (var i = 0; i < length; i++) {
  //     if (haystack[i].toUpperCase() === needle.toUpperCase()) return true;
  //   }
  //   return false;
  // }

  // Cost().then((data) => {
  //   console.log(data);
  // });

  totalSupply().then((data) => {
    setSupply(data);
    // if (inArray(walletAddress, wishList) === true) {
    //   setPrice(1);
    // }
  });
  function addWalletListener() {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", async (accounts) => {
        if (accounts.length > 0) {
          setWallet(accounts[0]);
          // if(inArray(walletAddress, wishList) === true) {
          //   setPrice(1);
          // }
          setStatus("how many? ☝️");
        } else {
          setWallet("");
          setStatus("Connect to Metamask 👇");
        }
      });
    } else {
      setStatus(
        // eslint-disable-next-line react/jsx-no-target-blank
        <a target="_blank" href={`https://metamask.io/download.html`}>
          Metamask required
        </a>
      );
    }
  }

  // Only " + (625 - supply) + " remaining!
  const mint = async () => {
    if (walletAddress !== "") {
      if (amount === 0) {
        setStatus("Enter Valid amount.");
      } else {
        setLoading(true);
        setStatus("Mint is in Progess. Please Wait.....");
        const { status } = await mintNFT(amount, price);
        if (status === "🙌 NFT Successfully Minted") {
          setSupply(parseInt(supply) + parseInt(amount));
        } else if (status === "👆🏽 Please connect to Polygon Network.") {
          alert(status);
        }
        setStatus(status);
        setLoading(false);
      }
    } else {
      setStatus("🦊 Connect to Metamask");
    }
  };

  return (
    <div>
      <Header />
      <Mint
        status={status}
        price={price}
        amount={amount}
        setAmount={setAmount}
        mint={mint}
        loading={loading}
        supply={supply}
      />
      <About />
      <Traits />
      <Collection />
      <Roadmap />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
